import Map from "@commons/Map";
import { usePage } from "@hooks/usePage";
import { CircularProgress } from "@mui/material";
import { toast } from "react-toastify";
import { useEffect } from "react";
import { AppError } from "@utils/errors/appError";
import {
  REGISTER_TYPE_COLORS,
  REGISTER_TYPE_LABELS,
  type RegisterType,
} from "@typings/entities/registers/enums";
import type { RegisterGeoJsonProperties } from "@services/registers/getGeoJson/type";
import { useGetRegistersGeoJson } from "@services/registers/getGeoJson";
import type { RegistersFilters } from "@services/registers/list/type";
import RegisterPopup from "./Popup";
import { mapColorInRegisters } from "@utils/translator/registers";
import { usePermissions } from "@hooks/usePermissions";

const LEGENDS = Object.entries(REGISTER_TYPE_LABELS).map(([key, label]) => ({
  label,
  color: REGISTER_TYPE_COLORS[key as RegisterType].tw,
}));

function MapView({ appliedFilters }: { appliedFilters: RegistersFilters }) {
  const { openModal } = usePage();
  const { can } = usePermissions();

  const { data, isLoading, error } = useGetRegistersGeoJson(appliedFilters);

  const processedData = data ? mapColorInRegisters(data) : null;

  useEffect(() => {
    if (error) {
      const isAppError = error instanceof AppError;

      const title = isAppError
        ? error.message
        : "Erro ao carregar os Registros! Tente novamente!";
      toast.error(title, { autoClose: 6000 });
    }
  }, [error]);

  const canCreateRegister = can("create", "registers");

  return (
    <div className="w-full h-[calc(100vh-12rem)] flex flex-col pt-2 gap-6">
      <div className="flex-1 bg-white rounded-lg shadow-md p-4 min-h-0">
        {isLoading ? (
          <CircularProgress />
        ) : (
          <>
            <Map.Root>
              {canCreateRegister && (
                <Map.Button onClick={() => openModal("newRegister")}>
                  Novo Registro
                </Map.Button>
              )}
              <Map.Draw<RegisterGeoJsonProperties>
                geoJsonData={processedData}
                popupComponent={RegisterPopup}
                canCreate={canCreateRegister}
                modalToOpen="newRegister"
                coordinatesButtonLabel="Novo Registro"
              />
              <Map.Footer legends={LEGENDS} />
            </Map.Root>
          </>
        )}
      </div>
    </div>
  );
}

export default MapView;
